import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {

    const location = useLocation();
    const userID = sessionStorage.getItem("TRCUserId");
	  const userEmail = sessionStorage.getItem("TRCUserEmail");
	  const userName = sessionStorage.getItem("TRCUserName");
	  const userPosition = sessionStorage.getItem("TRCUserPosition");
	  const userType = sessionStorage.getItem("TRCUserType");
    const [clientData, setClientData] = useState('');
    const [clientId, setClientId] = useState(null);
    const [formData, setFormData] = useState({});

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };

    useEffect(() => {
        const client = getQueryParam('id');
        setClientId(client);
    }, [userID]);

	

    const getEmployee = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/clients/reports/', {clientId: clientId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setClientData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	useEffect(() => {
		getEmployee();
	},[clientId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ['empId']: userID,
            ['clientId']: clientId
        }));
    };

    //console.log(formData);

    const updateData = async (e) => {
        e.preventDefault();

        try {
			const response = await axios.post('https://api.trucoo.in/clients/report/', formData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				getEmployee();
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">

			<div class="box">
                <div class="box-header with-border">
				  <h4 class="box-title">Client Data</h4>
				  <p class="mb-0 box-subtitle">Client Reports</p>
				</div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-lg-8 mt-4">
                            <div class="row">
                                <div class="col-lg-6 mt-2">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                          <tr>
                                            <td width="35%" style={{padding: '5px'}}>Client Name</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.name}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Company Name</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.companyName}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Address</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.companyAddress}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>GST</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.gst}</td>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-2">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                        <tr>
                                            <td width="35%" style={{padding: '5px'}}>Email</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.email}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Company Phone</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.companyContact}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Alternate Phone</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.phone}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Location</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.location}</td>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-4">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                          <tr>
                                            <td width="35%" style={{padding: '5px'}}>Added On</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.date}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Last Update On</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.reportData[0]?.date}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Next Update On</td>
                                            <td style={{padding: '5px'}}>{clientData[0]?.reportData[0]?.nextUpdate}</td>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-4">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                          <tr>
                                            <p class="text-center">Remarks</p>
                                            <p>{clientData[0]?.reportData[0]?.remarks}</p>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 mt-4">
                            <div class="row">
                              <form onSubmit={updateData}>
                                <div class="col-lg-12 mt-2">
                                    <label class="form-label">Action</label>
                                    <select class="form-control" name="action" value={formData.action} onChange={handleChange} required >
                                        <option value="" hidden>Select an option</option>
                                        <option>Company Visit</option>
                                        <option>Call</option>
                                        <option>Outside Visit</option>
                                    </select>
                                </div>
                                <div class="col-lg-12 mt-2">
                                    <label class="form-label">Remarks</label>
                                    <textarea class="form-control" rows="4" name="remarks" value={formData.remarks} onChange={handleChange} required></textarea>
                                </div>
                                <div class="col-lg-12 mt-2">
                                    <label class="form-label">Next Update Date</label>
                                    <input type="date" class="form-control" name="date" value={formData.date} onChange={handleChange} required />
                                </div>
                                <div class="col-lg-12 mt-2" align="center">
                                    <button type="submit" class="btn btn-primary w-100">Update</button>
                                </div>
                              </form>
                            </div>
                        </div>

                       
                        
                    </div>
                </div>


				<div class="box-header with-border">
				  <p class="mb-0 box-subtitle">Client Reports</p>
				</div>
				<div class="box-body">
					<div class="table-responsive">
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						<thead>
							<tr class="text-dark">
								<th>Date</th>
								<th>Action</th>
								<th>Remarks</th>
								<th>Next Update</th>
								
							</tr>
						</thead>
						<tbody>
							{clientData.length > 0 ? clientData[0].reportData.map((reports, index) =>
							<tr key={index}>
								<td class="text-dark">{reports.date}</td>
								<td>{reports.status}</td>
								<td>{reports.remarks}</td>
								<td>{reports.nextUpdate}</td>
							</tr>
							):(
								<tr>
									<td colSpan={6}>No Client Data</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;